import { SOFTWARE } from '../constant/actionTypes';

const getSoftwareSettingsList = (state, action) => {
  switch (action.type) {
    case SOFTWARE.SOFTWARE_SETTINGS.INITIATE:
      return { isFetching: true };
    case SOFTWARE.SOFTWARE_SETTINGS.SUCCESS:
      return { isFetching: false, payload: action.payload };
    case SOFTWARE.SOFTWARE_SETTINGS.ERROR:
      return { isFetching: false, payload: action.payload };
    default:
      return state || [];
  }
};

export default getSoftwareSettingsList;
